const tmpWikiPrefixPaths = [
  'https://kamigame.jp/wiki/test/page/358086035449617912.html',
  'https://kamigame.jp/wiki/dbd/page/358488020011201556.html',
  'https://kamigame.jp/wiki/dbd/page/359105379130461444.html',
  'https://kamigame.jp/wiki/dbd/page/359105426526046861.html',
  'https://kamigame.jp/wiki/dbd/page/359388644521315301.html',
  'https://kamigame.jp/wiki/dbd/page/359390747830566204.html',
  'https://kamigame.jp/wiki/dbd/page/359390853812227045.html',
  'https://kamigame.jp/wiki/dbd/page/359391466415495207.html',
  'https://kamigame.jp/wiki/dbd/page/359391842577478495.html',
  'https://kamigame.jp/wiki/dbd/page/359392151395664834.html',
  'https://kamigame.jp/wiki/mhwilds/page/356584016566078652.html',
  'https://kamigame.jp/wiki/mhwilds/page/357069801576780735.html',
  'https://kamigame.jp/wiki/mhwilds/page/358030903622017193.html',
  'https://kamigame.jp/wiki/mhwilds/page/358043822330004069.html',
  'https://kamigame.jp/wiki/mhwilds/page/358063727624368849.html',
  'https://kamigame.jp/wiki/mhwilds/page/358074354631753812.html',
  'https://kamigame.jp/wiki/mhwilds/page/358095636731580425.html',
  'https://kamigame.jp/wiki/mhwilds/page/358102093308941524.html',
  'https://kamigame.jp/wiki/mhwilds/page/358354778314553056.html',
  'https://kamigame.jp/wiki/mhwilds/page/358387685800286351.html',
  'https://kamigame.jp/wiki/mhwilds/page/358404092021743621.html',
  'https://kamigame.jp/wiki/mhwilds/page/358406426470664212.html',
  'https://kamigame.jp/wiki/mhwilds/page/358406571979503108.html',
  'https://kamigame.jp/wiki/mhwilds/page/358409580385990148.html',
  'https://kamigame.jp/wiki/mhwilds/page/358412646069874796.html',
  'https://kamigame.jp/wiki/mhwilds/page/358414988571890727.html',
  'https://kamigame.jp/wiki/mhwilds/page/358416433979375676.html',
  'https://kamigame.jp/wiki/mhwilds/page/358429358676823591.html',
  'https://kamigame.jp/wiki/mhwilds/page/358429358743932455.html',
  'https://kamigame.jp/wiki/mhwilds/page/358433290618701103.html',
  'https://kamigame.jp/wiki/mhwilds/page/358433290719364399.html',
  'https://kamigame.jp/wiki/mhwilds/page/358433373514925963.html',
  'https://kamigame.jp/wiki/mhwilds/page/358443008535873837.html',
  'https://kamigame.jp/wiki/mhwilds/page/358447641882826581.html',
  'https://kamigame.jp/wiki/mhwilds/page/358447892098235917.html',
  'https://kamigame.jp/wiki/mhwilds/page/358448157681539180.html',
  'https://kamigame.jp/wiki/mhwilds/page/358449040465116685.html',
  'https://kamigame.jp/wiki/mhwilds/page/358449872229145756.html',
  'https://kamigame.jp/wiki/mhwilds/page/358538680140342240.html',
  'https://kamigame.jp/wiki/mhwilds/page/358677771498616756.html',
  'https://kamigame.jp/wiki/bluearchive/page/358061057027110545.html',
  'https://kamigame.jp/wiki/bluearchive/page/358063300744840997.html',
  'https://kamigame.jp/wiki/bluearchive/page/358067079963744670.html',
  'https://kamigame.jp/wiki/bluearchive/page/358331944590677137.html',
  'https://kamigame.jp/wiki/bluearchive/page/358338206619457784.html',
  'https://kamigame.jp/wiki/bluearchive/page/358339605369459806.html',
  'https://kamigame.jp/wiki/bluearchive/page/358345907009280624.html',
  'https://kamigame.jp/wiki/hittheworld/page/358183318203690723.html',
  'https://kamigame.jp/wiki/hittheworld/page/358227765108937067.html',
  'https://kamigame.jp/wiki/hittheworld/page/358227806884249356.html',
  'https://kamigame.jp/wiki/hittheworld/page/358227842049277756.html',
  'https://kamigame.jp/wiki/hittheworld/page/358227884176869245.html',
  'https://kamigame.jp/wiki/hittheworld/page/358227926019243836.html',
  'https://kamigame.jp/wiki/hittheworld/page/358227970696969352.html',
  'https://kamigame.jp/wiki/hittheworld/page/358228007204208396.html',
  'https://kamigame.jp/wiki/hittheworld/page/358228062032133256.html',
  'https://kamigame.jp/wiki/hittheworld/page/358228127916238684.html',
  'https://kamigame.jp/wiki/hittheworld/page/358228177425826189.html',
  'https://kamigame.jp/wiki/hittheworld/page/358228220174171272.html',
  'https://kamigame.jp/wiki/hittheworld/page/358328886825620625.html',
  'https://kamigame.jp/wiki/onepiece-bountyrush/page/358361987769495062.html',
  'https://kamigame.jp/wiki/onepiece-bountyrush/page/358819630459914468.html',
  'https://kamigame.jp/wiki/onepiece-bountyrush/page/358819630527023332.html',
  'https://kamigame.jp/wiki/onepiece-bountyrush/page/358819630594132196.html',
  'https://kamigame.jp/wiki/onepiece-bountyrush/page/358821504374278372.html',
  'https://kamigame.jp/wiki/onepiece-bountyrush/page/358946680810279914.html',
  'https://kamigame.jp/wiki/onepiece-bountyrush/page/358949037472245268.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/357596785927047885.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/357596786430364365.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/357598466148464046.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/357889385540147523.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/357894130153591354.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/357899357229419471.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/357906844280182638.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/357925812801945616.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/357927289381457751.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/357929267264226568.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/357946811383596240.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/357949559189582315.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/357949559374131691.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358041931118288089.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358056107479976809.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358056149422972836.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358056395813215287.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358056662453484428.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358059517650433681.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358063337788993379.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358090311727082516.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358094309200809993.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358094310744313865.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358094310878531593.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358094311516041250.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358094312472351713.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358094313462207457.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358094313982301153.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358094316515677020.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358094317136413955.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358094317253854467.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358186017758440887.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358186017825549751.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358186017892658615.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358192790334636066.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358199583345486164.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358203607629224752.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358229969182135888.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358232478315479437.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358232616945625509.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358232693768464220.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358232760055279249.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358238976986872968.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358239108671241352.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358239167357966809.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358242856768432144.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358242857942837264.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358322865549929429.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358326963133264884.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358327185951464695.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358327542651861508.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358327759648373252.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358334634146200188.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358337625423089565.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358338234469582263.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358376242396838266.html',
  'https://kamigame.jp/wiki/ryugagotoku8-gaiden/page/358489311504517775.html',
];

module.exports = tmpWikiPrefixPaths;
